/**
 * Adds an indefinite article to the given water type description.
 * In some cases it add some more information to the description like "a part of an ocean".
 *
 * @param descriptionOfWaterType - The type of water to which an indefinite article should be added.
 * @returns A string with the indefinite article added to the water type description.
 */
import { WaterTypes } from '../../generated/graphql';

export const addIndefiniteArticleToWaterType = (descriptionOfWaterType: WaterTypes): string => {
  switch (descriptionOfWaterType) {
    case WaterTypes.lake:
      return 'a lake';
    case WaterTypes.canal:
      return 'a canal';
    case WaterTypes.ocean:
      return 'a part of an ocean';
    case WaterTypes.swamp:
      return 'a swamp';
    case WaterTypes.estuary:
      return 'an estuary';
    case WaterTypes.stream:
      return 'a stream';
    default:
      return 'a water';
  }
};
